import Module from '../../core/module';





export default Module.extend( {

    events: {

        'click .-open-types'() {
            this.trigger( this.constructor.TYPES, {
                cluster: this.state().cluster,
            } )
        },

        'click .-open-type-groups'() {
            this.trigger( this.constructor.TYPEGROUPS, {
                cluster: this.state().cluster,
            } )
        },

        'click .-open-statuses'() {
            this.trigger( this.constructor.STATUSES, {
                cluster: this.state().cluster,
            } )
        },

        'click .-open-priorities'() {
            this.trigger( this.constructor.PRIORITIES, {
                cluster: this.state().cluster,
            } )
        },

        'click .-open-fields'() {
            this.trigger( this.constructor.FIELDS, {
                cluster: this.state().cluster,
            } )
        },

        'click .-open-stickers'() {
            this.trigger( this.constructor.STICKERS, {
                cluster: this.state().cluster,
            } )
        },

        'click .-open-capabilities'() {
            this.trigger( this.constructor.CAPABILITIES, {
                cluster: this.state().cluster,
            } )
        },

        'click .-open-servers'() {
            this.trigger( this.constructor.SERVERS, {
                cluster: this.state().cluster,
            } )
        },

        'click .-open-scripts'() {
            this.trigger( this.constructor.SCRIPTS, {
                cluster: this.state().cluster,
            } )
        },

    }

}, {

    TYPES: 'types',

    TYPEGROUPS: 'type-groups',

    FIELDS: 'fields',

    STICKERS: 'stickers',

    STATUSES: 'statuses',

    PRIORITIES: 'priorities',

    CAPABILITIES: 'capabilities',

    SERVERS: 'servers',

    SCRIPTS: 'scripts',

} );


// WEBPACK FOOTER //
// ./src/js/module/refbooks/refbooks.module.js